import React from 'react'

import { DEFAULT_LETTER_HEADER } from '../../shared/variables'
import RichTextReadOnly from '../inputFields/RichTextReadOnly'
import { FlexColumn } from '../styles/Containers'
import BodyText from '../styles/Text'

const LETTER_TEMPLATE_HEADER_DESCRIPTION =
  'The date will automatically be added to the top of the letter when it is sent. ' +
  'The following text will automatically be added to the top of every letter when a draft is created:'

function LetterTemplateHeader() {
  return (
    <FlexColumn gap="10px">
      <BodyText>{LETTER_TEMPLATE_HEADER_DESCRIPTION}</BodyText>
      <RichTextReadOnly value={DEFAULT_LETTER_HEADER} />
    </FlexColumn>
  )
}

export default LetterTemplateHeader
